/**
 * @copyright Elmelo Ltd.
 */

import React from 'react'

import { Router } from "@reach/router"

import ProfileHome from './home'

import P404 from '../_common/404'

/**
 */
class App_Profile extends React.PureComponent
{
    /**
     */
    // constructor( props )
    // {
    //     super( props )
    // }

    /**
     */
    render()
    {
        return (
            <Router>
                <ProfileHome path='home'/>
                <P404 default />
            </Router>
            )
    }   // render
}   // class App_Profile

/**
 */
export {App_Profile, ProfileHome}
